import { Input } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import PhoneInput from 'react-phone-input-2';
import getCountryISO2 from 'country-iso-3-to-2';
import getPhoneInputTranslations from './localization/CustomPhoneInputLanguages';
import { ThemeContext } from '../../../shared/contexts/Theme.context';
import styles from './CustomPhoneInput.styles';
import PhonePrefixConstants from './PhonePrefixConstants';

export default function CustomPhoneInput({
  hint,
  setPhonePrefix,
  phoneNumber,
  value,
  defaultCountry,
  ...props
}) {
  let countryInIso2 = defaultCountry?.length > 2 ? getCountryISO2(defaultCountry) : defaultCountry;
  let prefixFromNumber = getPrefixFromNumber(phoneNumber);
  if (prefixFromNumber?.charAt(0) === '+') prefixFromNumber = prefixFromNumber.slice(1);

  let defaultPrefix =
    prefixFromNumber && isPrefixValid(prefixFromNumber)
      ? prefixFromNumber
      : PhonePrefixConstants[countryInIso2];

  if (defaultPrefix?.charAt(0) === '+') defaultPrefix = defaultPrefix.slice(1);

  phoneNumber = getFormattedNumber(phoneNumber, defaultPrefix);

  const [number, setNumber] = useState(phoneNumber);
  const [prefix, setPrefix] = useState(defaultPrefix);
  const { state: theme } = useContext(ThemeContext);
  const preferredCountries = ['es', 'it', 'de', 'fr', 'pt', 'gb', 'jp', 'cn', 'us', 'mx'];
  const pickerWidth = 100;

  const translations = getPhoneInputTranslations(theme.lang);
  const localization = translations ? { localization: translations } : null;

  useEffect(() => {
    if (phoneNumber) {
      onNumberEntered({ target: { value: phoneNumber } });
    }
  }, [phoneNumber]);

  useEffect(() => {
    if (defaultPrefix) {
      onPrefixSelected(defaultPrefix);
    }
  }, [defaultPrefix]);

  return (
    <div style={styles.container}>
      <div>
        <PhoneInput
          inputStyle={{ ...styles.inputStyle, width: pickerWidth }}
          style={{ width: pickerWidth, borderRadius: 8 }}
          buttonStyle={{ borderRadius: 8, borderWidth: 0 }}
          containerStyle={{ width: pickerWidth, borderRadius: 8 }}
          enableSearch
          inputProps={{ disabled: true }}
          preferredCountries={preferredCountries}
          onChange={onPrefixSelected}
          country={getCountryISO2(defaultCountry)?.toLowerCase()}
          value={prefix}
          {...localization}
        />
      </div>
      <div>
        <Input
          placeholder={hint}
          bordered={false}
          style={styles.inputNumber}
          onChange={event => onNumberEntered(event)}
          value={number}
        />
      </div>
    </div>
  );

  function onNumberEntered(event) {
    setNumber(event.target.value);
    props.onChange(event);
  }

  function onPrefixSelected(prefix) {
    if (!prefix) return;
    setPrefix(prefix);
    setPhonePrefix(prefix);
  }

  function getFormattedNumber(input, prefix) {
    let ret = input;
    const stringPrefix = `+${prefix}`;
    if (input && input.startsWith(stringPrefix)) {
      ret = input.substring(stringPrefix.length);
    }

    return ret;
  }

  function getPrefixFromNumber(input) {
    if (!input) return null;
    const match = input.match(/^\+\d{1,5}(?=\s)/);
    return match ? match[0] : null;
  }

  function isPrefixValid(value) {
    for (const countryCode in PhonePrefixConstants) {
      if (PhonePrefixConstants.hasOwnProperty(countryCode)) {
        if (PhonePrefixConstants[countryCode] === value) {
          return true;
        }
      }
    }

    return false;
  }
}
